
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';


const TestimonalModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [loading, setLoading] = useState(false);
    const token = decryptToken("accessToken") || ""

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };





    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const payload = {
            ...data,
            // main_id: isLoggedIn.main_id,

        };

        try {
            const response = await fetch(`${url}/testomonial${data.id ? `/${data.id}` : ""}`, {
                method: data.id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();
            if (response.ok) {
                toast.success(data.id ? "updated successfully" : "saved successfully");
                sliderFetch();
                setIsOpen(false);
            } else {
                toast.error("Failed to save slider");
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false);
        }


    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Testimonials</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    {[
                        { name: "heading", label: "Headline" },
                        { name: "testomonial_message", label: "Message" },
                        { name: "user_name", label: "Author" },
                    ].map(({ name, label, type = "text" }) => (
                        <div key={name} className="oms-form-group">
                            <label htmlFor={name} className="oms-form-label">{label}</label>
                            <input
                                type={type}
                                id={name}
                                name={name}
                                value={data[name]}
                                onChange={handleChange}
                                placeholder={`Enter ${label} ${label === "Url" ? "(https://example.com)" : ""}`}
                            />
                        </div>
                    ))}






                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        {
                            loading ? <button type="button">Submiting...</button> :
                                <button type="submit">Submit</button>
                        }

                    </div>
                </form>
            </div>
        </div>
    );
};


export default TestimonalModal;
